<template>
	<div class="float-e-margins ibox-content ibox_main" v-loading="loadingstatus">
		<div class="form-horizontal">
			<div class="form-group">
				<label class="col-sm-1 control-label">字典类型</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model="udctype" v-bind:readonly='!canEnable'>
				</div>
			</div>
			<div class="form-group">
				<div class="table-responsive">
				<table class="table table-striped table-bordered table-hover">
					<thead>
						<tr role="row">
							<th v-for="(thead, index) in theadList" :key="'theadDc' + index">{{thead}}</th>
							<th class="text-center" v-if="!isRead"></th>
						</tr>
					</thead>
					<transition-group name="list-complete" tag="tbody">
						<tr v-for="(udcInfo,index) in udcList" v-bind:key="index + 'udcinfoDic'" class="list-complete-item" @click="!isRead && toClickEdit($event,index)">
							<td>{{udcInfo.udcName}}</td>
							<td>{{udcInfo.orderNo}}</td>
							<td>{{udcInfo.udcText}}</td>
							<td>{{udcInfo.udcEnable}}</td>
							<td>{{udcInfo.udcCode}}</td>
							<td>{{udcInfo.updateTime}}</td>
							<td>{{udcInfo.updateId}}</td>
							<td class="text-center" @click="removeItem(index)" v-if="!isRead">
								<a class="glyphicon glyphicon-trash"></a>
							</td>
						</tr>
					</transition-group>
				</table>
			</div>
			</div>
			<div class="form-group" v-if='!isRead'>
				<div class="col-sm-2">
					<label for="">名称：</label>
					<input type="text" class="form-control" v-model.trim="udcEdit.udcName">
				</div>
				<div class="col-sm-2">
					<label for="">顺序：</label>
					<input type="text" class="form-control" v-model.trim="udcEdit.orderNo">
				</div>
				<div class="col-sm-2">
					<label for="">备注：</label>
					<input type="text" class="form-control" v-model.trim="udcEdit.udcText">
				</div>
				<div class="col-sm-2">
					<label for="">启用：</label>
					<select class="form-control" v-model="udcEdit.udcEnable">
						<option v-for="option in udcEnableList" v-bind:value="option.udcVale">
							{{ option.udcEnableText }}
						</option>
					</select>
				</div>
				<div class="col-sm-2">
					<label for="">CODE：</label>
					<input type="text" class="form-control" v-model.trim="udcEdit.udcCode">
				</div>
				<div class="col-sm-2">
					<label for="">&#12288;</label><br />
								<button	type="button" class="btn btn-primary" @click="openModalMsg('modalConfirm','确认保存？')">保存</button>
				</div>
			</div>
			<div class="form-group">
				<div class="col-sm-12 text-center">
					<a  class="btn btn-primary white" v-on:click="close">关闭</a>
				</div>
				<!--<div class="col-sm-6 text-center">
					<a class="btn btn-primary white" v-on:click="openModalMsg('modalConfirm')">保存</a>
					<!--<a class="btn btn-primary white">关闭</a>-->
				<!--</div>-->
			</div>
		</div>
		<!--SubPage组件弹框开始-->
		<sub-modal ref="modalConfirm" size="small" title="提示">
			{{messageStr}}
			<div slot="footer">
				<button class="btn btn-primary" @click="closeModalMsg('modalConfirm')">取消</button>
				<button class="btn btn-primary" @click="confirmSubBtn">确定</button>
			</div>
		</sub-modal>
		<sub-modal ref="modalWarn" size="small" title="提示">
			{{messageStr}}
			<div slot="footer">
				<button class="btn btn-primary" @click="closeModalMsg('modalWarn')">确定</button>
			</div>
		</sub-modal>
		<sub-modal ref="modal2" size="small" title="提示" :scroll='scrollTop'  v-on:cancel="closeModalMsg('modal2')">
			确定删除 {{udcList[lastIndex]?udcList[lastIndex].udcname:''}} 字典？
			<div slot="footer">
		            <button @click="closeModalMsg('modal2')" class="btn btn-primary">取消</button>
		            <button @click="removePlanItem()" class="btn btn-primary">确定</button>
		    </div>
		</sub-modal>
		<!--SubPage组件弹框结束-->
	</div>
</template>
<script>
	import SubModal from 'components/common/SubModal'
	import { OPERATE_EXCEPTION } from 'static/message'
	export default{
	  name: 'PageDictionaryEidt',
	  props: ['dataInfo', 'isRead', 'editType'],					// 字典类型，是否可编辑，是否可新建字典类
	  components: {
	    SubModal
	  },
	  watch: {
	    dataInfo (val) {
	      this.udctype = val
	      if (!this.dataInfo == '') {
	        this.getTableInfo()
	      } else {
	        this.udcList = ''
	        this.loadingstatus = false
	      }
	    },
	    editType (val) {
	      this.canEnable = val
	    }
	  },
	  data ()	{
	    return {
	      udcEnableList: [
					{udcEnableText: '已启用', udcVale: 1},
					{udcEnableText: '未启用', udcVale: 0}
	      ],
	      loadingstatus: false,
	      messageStr: '',
	      theadList: ['名称', '顺序', '备注', '启用', 'CODE', '修改时间', '修改人'],
	      udctype: '',
	      udcEdit: {																// 编辑框绑定内容
	        udcName: '',
	        orderNo: '',
	        udcTypes: '',
	        udcText: '',
	        udcEnable: null,
	        udcCode: ''
	      },
	      udcList: [],
	      newUdc: true,															// 是否为新建项
	      canEnable: true,
	      lastIndex: 0,
	      scrollTop: '0'
	    }
	  },
	  methods: {
			// 初始化拉取数据
	    getTableInfo: function () {
	      this.udcEdit = {}
	      this.loadingstatus = true
	      this.$http.get(process.env.API_ROOT + '/system/udcs/types/' + this.udctype)
					.then((response) => {
	  if (response.body.success) {
	    if (response.body.data) {
	      this.udcList = response.body.data
	      this.loadingstatus = false
	    }
	  } else {
					       this.openModalMsg(response.body.message)
				       this.loadingstatus = false
	  }
	  this.loadingstatus = false
	}, (response) => {
					   this.openModalMsg(response.body.message)
				   this.loadingstatus = false
	})
					.catch((response) => {
				        this.openModalMsg(OPERATE_EXCEPTION)
			        this.loadingstatus = false
	})
	      this.refUdcEdit()
	    },
			// 模块控制相关
	    close () {
	      this.$emit('cancel')
	      this.newUdc = true
	      this.udcEdit = {}
	      if (this.canEnable) {
	        this.udctype = ''
	      }
	      this.refUdcEdit()
	    },
	    closeModalMsg (ref) {
	      this.$refs[ref].close()
	    },
	    openModalMsg (ref, msg) {
	      this.messageStr = msg
	      this.$refs[ref].open()
	    },
			// 删除相关项目
	    removeItem () {
	      this.openModalMsg('modal2')
	    },
	    removePlanItem () {
	      this.closeModalMsg('modal2')
	      this.$http.delete(process.env.API_ROOT + '/system/udcs/page/' + this.udcList[this.lastIndex].id)
				.then(res => {
	  if (res.data.success) {
	    this.getTableInfo()
	  } else {
	    this.openModalMsg('modalWarn', res.data.message)
	  }
	}, res => {
	  this.loadingstatus = false
	  this.openModalMsg('modalWarn', res.data.message)
	}).catch(res => {
	  this.loadingstatus = false
	  this.openModalMsg('modalWarn', OPERATE_EXCEPTION)
	})
	    },
			// 存储字典内容
	    confirmSubBtn () {
	      this.closeModalMsg('modalConfirm')
	      this.udcEdit.udcTypes = this.udctype
	      if (this.udcEdit.udcCode && (this.udcEdit.udcEnable === 1 || this.udcEdit.udcEnable === 0) && this.udcEdit.udcName && this.udcEdit.udcTypes) {
	        if (this.newUdc) { // 判断是否为新增项
	          this.$http.post(process.env.API_ROOT + '/system/udcs/page/', this.udcEdit)
					.then((response) => {
	  this.loadingstatus = true
	  if (response.body.success) {
	    if (response.body.code === 200) {
	      this.getTableInfo()
	      this.canEnable = false
	    }
	  } else {
	    this.loadingstatus = false
	  }
	}, (response) => {
	  this.loadingstatus = false
	  this.openModalMsg('modalWarn', response.data.message)
	})
					.catch((response) => {
	  this.loadingstatus = false
	  this.openModalMsg('modalWarn', response.data.message)
	})
	        } else {
	          this.$http.put(process.env.API_ROOT + '/system/udcs/page/' + this.udcList[this.lastIndex].id, this.udcEdit)
				.then((response) => { // 修改项
	  this.loadingstatus = true
	  if (response.body.success) {
	    if (response.body.code === 200) {
	      this.getTableInfo()
	      this.loadingstatus = false
	    }
	  } else {
	    this.loadingstatus = false
	    this.openModalMsg('modalWarn', response.data.message)
	  }
	}, (response) => {
	  this.loadingstatus = false
	  this.openModalMsg('modalWarn', response.data.message)
	})
					.catch((response) => {
	  this.loadingstatus = false
	  this.openModalMsg('modalWarn', response.data.message)
	})
	        }
	      } else {
	        this.openModalMsg('modalWarn', '字典表名称，是否启用，类型，Code等为必填项')
	      }
	    },
			// 选中项颜色修正
	    toClickEdit: function (event, index) {
	      this.lastIndex = index
	      if (this.isRead) return
	      if (event.target.parentNode == event.currentTarget.lastChild) return
	      if (event.currentTarget.classList.contains('success')) {
	        this.udcEdit = {}
	        this.udcEdit.udcTypes = this.udctype
	        this.newUdc = true
	        event.currentTarget.classList.toggle('success')
	      } else {
	        let childArr = event.currentTarget.parentNode.childNodes
	        const len = childArr.length
	        for (var i = 0; i < len; i++) {
	          childArr[i].classList.remove('success')
	        }
	        this.udcEdit = this.deepCopy(this.udcList[index])
	        this.udcEdit.udcTypes = this.udctype
	        event.currentTarget.classList.toggle('success')
	        this.newUdc = false
	      }
	    },
			// 深拷贝
	    deepCopy: function (source) {
	      var result = {}
	      for (var key in source) {
	        result[key] = typeof source[key] === 'object' ? this.deepCopy(source[key]) : source[key]
	      }
			   	return result
	    },

			// 刷新被选中项背景颜色
	    refUdcEdit: function () {
	      this.udcEdit = {}
	      const oTb = document.querySelectorAll('table')[1]
	      if (oTb) {
	        if (oTb.querySelectorAll('tr')[this.lastIndex + 1] && oTb.querySelectorAll('tr')[this.lastIndex + 1].classList.contains('success')) {
	          oTb.querySelectorAll('tr')[this.lastIndex + 1].classList.remove('success')
	        }
	      }
	      this.lastIndex = 0
	    }

	  }

	}
</script>
<style>
	.select{
		background:reb(232,282,225);
	}
</style>



// WEBPACK FOOTER //
// PageDictionaryEdit.vue?caf644cc